// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./Img/Background-1.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Root Color Variables */
:root {
  --primary-white: #fff;
  --primary-black: #000;
  --primary-grey: #73739a;
  --primary-blue: #6d72f6;
  --primary-green: #08ce8a;
  --primary-black2: #1c1c57;
}

/* BlogHeader Container */
.BlogHeader-container {
  position: relative;
  height: 60vh; /* Default height */
  background-color: var(--primary-blue);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  transition: all 0.8s ease-in-out;
  top: -130px; /* Remove negative top values */
}

/* Dark Overlay */
.overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.164);
  z-index: 1;
}

/* BlogHeader Text */
.BlogHeader-text {
  color: #fff;
  font-size: 4rem;
  font-family: Arial, sans-serif;
  z-index: 2;
  opacity: 0;
  animation: fadeIn 2s forwards, slideIn 2s forwards;
}

/* Keyframe Animations */
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes slideIn {
  from {
    transform: translateY(50px);
  }
  to {
    transform: translateY(0);
  }
}

/* Responsive Design */
@media (max-width: 1200px) {
  .BlogHeader-container {
    height: 50vh; /* Adjust height for desktops */
  }
  .BlogHeader-text {
    font-size: 3.5rem;
  }
}

@media (max-width: 1024px) {
  .BlogHeader-container {
    height: 50vh; /* Adjust height for laptops */
  }
  .BlogHeader-text {
    font-size: 3rem;
  }
}

@media (max-width: 768px) {
  .BlogHeader-container {
    height: 50vh; /* Adjust height for tablets */
  }
  .BlogHeader-text {
    font-size: 2.5rem;
  }
}

@media (max-width: 576px) {
  .BlogHeader-container {
    height: 50vh; /* Adjust height for smaller devices */
  }
  .BlogHeader-text {
    font-size: 2rem;
  }
}

@media (max-width: 375px) {
  .BlogHeader-text {
    font-size: 1.8rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/BlogHeader/BlogHeader.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB;EACE,qBAAqB;EACrB,qBAAqB;EACrB,uBAAuB;EACvB,uBAAuB;EACvB,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,YAAY,EAAE,mBAAmB;EACjC,qCAAqC;EACrC,yDAA+C;EAC/C,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,gCAAgC;EAChC,WAAW,EAAE,+BAA+B;AAC9C;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,sCAAsC;EACtC,UAAU;AACZ;;AAEA,oBAAoB;AACpB;EACE,WAAW;EACX,eAAe;EACf,8BAA8B;EAC9B,UAAU;EACV,UAAU;EACV,kDAAkD;AACpD;;AAEA,wBAAwB;AACxB;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,YAAY,EAAE,+BAA+B;EAC/C;EACA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,YAAY,EAAE,8BAA8B;EAC9C;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,YAAY,EAAE,8BAA8B;EAC9C;EACA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,YAAY,EAAE,sCAAsC;EACtD;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF","sourcesContent":["/* Root Color Variables */\n:root {\n  --primary-white: #fff;\n  --primary-black: #000;\n  --primary-grey: #73739a;\n  --primary-blue: #6d72f6;\n  --primary-green: #08ce8a;\n  --primary-black2: #1c1c57;\n}\n\n/* BlogHeader Container */\n.BlogHeader-container {\n  position: relative;\n  height: 60vh; /* Default height */\n  background-color: var(--primary-blue);\n  background-image: url('./Img/Background-1.png');\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  overflow: hidden;\n  transition: all 0.8s ease-in-out;\n  top: -130px; /* Remove negative top values */\n}\n\n/* Dark Overlay */\n.overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.164);\n  z-index: 1;\n}\n\n/* BlogHeader Text */\n.BlogHeader-text {\n  color: #fff;\n  font-size: 4rem;\n  font-family: Arial, sans-serif;\n  z-index: 2;\n  opacity: 0;\n  animation: fadeIn 2s forwards, slideIn 2s forwards;\n}\n\n/* Keyframe Animations */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes slideIn {\n  from {\n    transform: translateY(50px);\n  }\n  to {\n    transform: translateY(0);\n  }\n}\n\n/* Responsive Design */\n@media (max-width: 1200px) {\n  .BlogHeader-container {\n    height: 50vh; /* Adjust height for desktops */\n  }\n  .BlogHeader-text {\n    font-size: 3.5rem;\n  }\n}\n\n@media (max-width: 1024px) {\n  .BlogHeader-container {\n    height: 50vh; /* Adjust height for laptops */\n  }\n  .BlogHeader-text {\n    font-size: 3rem;\n  }\n}\n\n@media (max-width: 768px) {\n  .BlogHeader-container {\n    height: 50vh; /* Adjust height for tablets */\n  }\n  .BlogHeader-text {\n    font-size: 2.5rem;\n  }\n}\n\n@media (max-width: 576px) {\n  .BlogHeader-container {\n    height: 50vh; /* Adjust height for smaller devices */\n  }\n  .BlogHeader-text {\n    font-size: 2rem;\n  }\n}\n\n@media (max-width: 375px) {\n  .BlogHeader-text {\n    font-size: 1.8rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
